import React from 'react';
import styles from './AccessDenied.module.css';
import { useAppConfig } from '../../context/AppConfigContext';
import { useAuth } from '../../context/AuthContext';

const AccessDenied = ({ onBack, activeScreen }) => {
  const { t } = useAppConfig();
  const { isGuest: temp } = useAuth();

  let textKey = 'default';

  if (activeScreen === 'examScreen' && temp) {
    textKey = 'examTemp';
  } else if (activeScreen === 'examScreen') {
    textKey = 'exam';
  } else if (activeScreen === 'game') {
    textKey = 'game';
  } else if (activeScreen === 'dialogScreen') {
    textKey = 'dialog';
  }

	return (
	  <div className={styles.overlay}>
		<div className={styles.modal}>
		  <h2 className={styles.title}>{t.accessDenied.title}</h2>
		  <p className={styles.text}>{t.accessDenied[textKey]}</p>

		  {temp && (
			<p className={styles.tempNote}>{t.accessDenied.tempUser}</p>
		  )}

		  <button className={styles.button} onClick={onBack}>
			{t.accessDenied.backButton}
		  </button>
		</div>
	  </div>
	);
};

export default AccessDenied;
